import {
  fetchGetDesktopFiltersMicrofrontend,
  IGetDesktopFiltersMicrofrontendRequest,
  TGetDesktopFiltersMicrofrontendResponse,
} from '../../repositories/desktop-filters-micro-frontend/v1/get-desktop-filters-microfrontend';
import { TApplicationContext } from '../../types/application';
import { mapManifestForConfig } from '../../utils/microfrontends';
import { candidateToSetting } from '@cian/config/shared';

const DEGRADATION_TELEMETRY_KEY = 'degradation.desktopFilters';

export const DESKTOP_FILTERS_MANIFEST_INFO_SETTING_KEY = 'desktopFiltersManifestInfo';

export const fetchDesktopFiltersManifest = async (
  { httpApi, microfrontendsRegistry, logger, telemetry, config }: TApplicationContext,
  parameters: IGetDesktopFiltersMicrofrontendRequest,
): Promise<void> => {
  try {
    const {
      response: { manifest },
    }: TGetDesktopFiltersMicrofrontendResponse = await fetchGetDesktopFiltersMicrofrontend({
      httpApi,
      parameters,
    });

    if (!manifest) {
      telemetry.increment(DEGRADATION_TELEMETRY_KEY);
      throw new Error('Манифест микрофронтенда фильтров не найден');
    }

    microfrontendsRegistry.register(manifest);

    config.injectSettings([
      candidateToSetting({
        key: DESKTOP_FILTERS_MANIFEST_INFO_SETTING_KEY,
        value: mapManifestForConfig(manifest),
      }).unwrap(),
    ]);
  } catch (ex) {
    telemetry.increment(DEGRADATION_TELEMETRY_KEY);
    logger.warning(ex, { degradation: 'Получение манифеста микрофронтенда фильтров' });
  }
};
